/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutoCompleteItem
 */
export interface AutoCompleteItem {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AutoCompleteItem
     */
    region?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AutoCompleteItem
     */
    country?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AutoCompleteItem
     */
    location?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AutoCompleteItem
     */
    station?: GuidIdCodeAndLabel;
}

export function AutoCompleteItemFromJSON(json: any): AutoCompleteItem {
    return AutoCompleteItemFromJSONTyped(json, false);
}

export function AutoCompleteItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCompleteItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'region': !exists(json, 'region') ? undefined : GuidIdCodeAndLabelFromJSON(json['region']),
        'country': !exists(json, 'country') ? undefined : GuidIdCodeAndLabelFromJSON(json['country']),
        'location': !exists(json, 'location') ? undefined : GuidIdCodeAndLabelFromJSON(json['location']),
        'station': !exists(json, 'station') ? undefined : GuidIdCodeAndLabelFromJSON(json['station']),
    };
}

export function AutoCompleteItemToJSON(value?: AutoCompleteItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'region': GuidIdCodeAndLabelToJSON(value.region),
        'country': GuidIdCodeAndLabelToJSON(value.country),
        'location': GuidIdCodeAndLabelToJSON(value.location),
        'station': GuidIdCodeAndLabelToJSON(value.station),
    };
}


